import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { memo, useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import moment from 'moment-timezone';

import * as actionCreators from '../../../store/actions';
import { activitiessearchTypes, activitiesTypes, memberinfoTypes } from '../../../types';
import {
  MemberType,
  reportotherbidStatus,
  reportotherquoteStatus,
  usaDateFormat,
} from '../../../utils/constants';
import { getActivitiesUsers } from '../../../store/actions';
import { useAuthContext } from 'src/auth/AuthProvider';

import ActivityReport from './bidquotereports';
import Bidwatch from './bidwatch';
import Downloads from './downloads';
import Ebidproposal from './ebidproposal';
import Notification from './notifications';
import Quotes from './quotes';
import UserActivity from './UserActivity';

interface propsTypes extends PropsFromRedux {
  history: any;
  match: any;
  activities: activitiesTypes;
  memberinfo: memberinfoTypes;
}

type CombinedProps = propsTypes & activitiessearchTypes;

function Activities(props: CombinedProps) {
  const dispatch = useDispatch();
  const {
    resetActivitiesDetails,
    getActivitiesNotifications,
    getActivitiesWatchs,
    history,
    getActivitiesPlanholders,
    getActivitiesEbidders,
    getActivitiesNotificationsMember,
    getActivitiesQuotes,
    setActivitiesDetails,
    getBidActivityReport,
    getQuoteActivityReport,
  } = props;
  const { auth } = useAuthContext();
  const Tab = props?.match?.params?.Tab;
  const [activeTab, setActiveTab] = useState(Tab ? Tab : 'notifications');

  useEffect(() => {
    dispatch(getActivitiesUsers({ page: 1, size: 100, pagination: false }));
  }, [dispatch]);

  const toggle = (tab: string) => {
    if (activeTab !== tab) {
      history.push(
        `/${
          auth?.memberType === MemberType.AgencyBuyer ? 'buyers' : 'suppliers'
        }/activities/${tab}`,
      );
    }
  };

  useEffect(() => {
    setActiveTab(Tab);
  }, [Tab, history]);

  useEffect(() => {
    getActivitiesNotifications({ page: 1, size: 100, pagination: false });
  }, [getActivitiesNotifications]);

  useEffect(() => {
    getActivitiesNotificationsMember({ page: 1, size: 500, pagination: false });
  }, [getActivitiesNotificationsMember]);

  useEffect(() => {
    getActivitiesWatchs({ page: 1, size: 100, pagination: false });
  }, [getActivitiesWatchs]);

  useEffect(() => {
    getActivitiesPlanholders({ page: 1, size: 100, pagination: false });
  }, [getActivitiesPlanholders]);

  useEffect(() => {
    getActivitiesEbidders({ page: 1, size: 100, pagination: false });
  }, [getActivitiesEbidders]);

  useEffect(() => {
    getActivitiesQuotes({ page: 1, size: 100, pagination: false });
  }, [getActivitiesQuotes]);

  useEffect(() => {
    setActivitiesDetails({ bidreport_internalLoader: true, activities_bidreports_search: false });
    const startDate = moment().subtract(1, 'months').format(usaDateFormat);
    const endDate = moment().format(usaDateFormat);
    getBidActivityReport({
      memberId: auth?.memberId,
      startDate,
      endDate,
      statusList: reportotherbidStatus,
      search: false,
    });
  }, [auth, getBidActivityReport, setActivitiesDetails]);

  useEffect(() => {
    setActivitiesDetails({
      quotereport_internalLoader: true,
      activities_quotereports_search: false,
    });
    const startDate = moment().subtract(1, 'months').format(usaDateFormat);
    const endDate = moment().format(usaDateFormat);
    getQuoteActivityReport({
      memberId: auth?.memberId,
      startDate,
      endDate,
      statusList: reportotherquoteStatus,
      search: false,
    });
  }, [auth, getQuoteActivityReport, setActivitiesDetails]);

  useEffect(() => {
    return () => {
      resetActivitiesDetails();
    };
  }, [resetActivitiesDetails]);

  let navList = [
    { name: 'Notifications', value: 'notifications', component: <Notification {...props} /> },
    { name: 'Watch List', value: 'watchlist', component: <Bidwatch {...props} /> },
    { name: 'Downloads', value: 'downloads', component: <Downloads {...props} /> },
    { name: 'eBid Responses', value: 'ebidresponses', component: <Ebidproposal {...props} /> },
    { name: 'Quotes', value: 'quotes', component: <Quotes {...props} /> },
  ];

  if (auth?.memberType === MemberType.AgencyBuyer) {
    const buyerList = [
      {
        name: 'Solicitation Reports',
        value: 'solicitationreports',
        component: <ActivityReport {...props} />,
      },
      { name: 'User Activities', value: 'useractivities', component: <UserActivity {...props} /> },
    ];
    navList = [...navList, ...buyerList];
  }

  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <Nav tabs>
              {navList.map((item: { value: string; name: string }, index: number) => (
                <NavItem key={index}>
                  <NavLink
                    className={classnames({ active: activeTab === item.value })}
                    onClick={() => toggle(item.value)}
                  >
                    {item.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {navList.map((item: { value: string; component: any }, index: number) => (
                <TabPane key={index} tabId={item.value}>
                  {activeTab === item.value && item.component}
                </TabPane>
              ))}
            </TabContent>
          </div>
        </div>
      </div>
    </>
  );
}

const connector = connect(
  (state: any) => ({
    activities: state.activities,
    memberinfo: state.memberinfo,
  }),
  dispatch => bindActionCreators({ ...actionCreators }, dispatch),
);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(memo(Activities));
